import parseJerseys from "./parseJerseys";
import { formatDateWithWeekDay, isSportToBeHidden, isCategoryToBeHidden, isTournamentToBeHidden, getRanking, getSplitDesc, addZero, getDayDesc } from "./utils";

export function parseCalendarData(data, day) {
    if (day === '') {
        day = data.tl[0];
    }

    const dates = data.tl.map(function(date) {
        let sports = [];
        if (date === day) {
        	let filteredSports = filterSports(data.sps);
            sports = filteredSports.map(sport => {
                const events = sport.evs.map(event => {
                    const [team1, team2] = getSplitDesc(event.d);
                    const [date, time] = getSplitDesc(formatDateWithWeekDay(event.ts).dayMonthTime);
                    return {
                        id: event.bid,
                        competition: `${event.dc} - ${event.dt}`,
                        desc: event.d,
                        team1,
                        team2,
                        date,
                        jerseys: parseJerseys(event.j, sport.id),
                        time,
                        timestampDB: event.ts,
                        pal: event.p,
                        avv: event.a,
                        categoryRef: event.cc,
                        tournamentRef: event.ct
                    };
                });
                return {
                    id: sport.id,
                    desc: sport.d,
                    ranking: getRanking(sport, true),
                    events
                };
            });
        }

        const formattedDate = formatDateWithWeekDay(`${date} 00:00:00`);
        const dayDesc = getDayDesc(formattedDate.weekDay);
        
        return {
            date: formattedDate.day,
            dateShort: formattedDate.dayMonthShort,
            dayDescShort: dayDesc,
            DBDate: date,
            sports
        };
    });

    const dateById = {};
    dates.forEach(function(date) {
        dateById[date.DBDate] = date;
        date.sportById = {};
        date.sports.forEach(function(sport) {
            date.sportById[sport.id] = sport;
        });
    });

    return {
        date: day,
        dateById,
        dates
    };
}

function filterSports(sports){
	let filteredSports = [];
	for(let ks in sports){
		const sport = sports[ks];
		let filteredEvents = [];
		if(!isSportToBeHidden(sport.id, sport.d)){
			for(let ke in sport.evs){
				const event = sport.evs[ke];
				const hideCategory = isCategoryToBeHidden(event.cc, event.dc);
				const hideTournament = isTournamentToBeHidden(event.ct, event.dt);
				if(!hideCategory && !hideTournament){
					filteredEvents.push(event);
				}
			}
		}
		if(filteredEvents.length > 0){
			sport.evs = filteredEvents;
			filteredSports.push(sport);
		}
	}
	return filteredSports;
}
